'use strict';

exports.__esModule = true;
exports.ThemeProvider = exports.getTheme = exports.defaultTheme = exports.lightTheme = exports.darkTheme = exports.colors = undefined;

var _styledComponents = require('styled-components');

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _darkTheme = require('./darkTheme');

var _darkTheme2 = _interopRequireDefault(_darkTheme);

var _lightTheme = require('./lightTheme');

var _lightTheme2 = _interopRequireDefault(_lightTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = _lightTheme2.default;

var getTheme = function getTheme(props) {
  return props.theme && Object.keys(props.theme).length !== 0 ? props.theme : defaultTheme;
};

exports.colors = _colors2.default;
exports.darkTheme = _darkTheme2.default;
exports.lightTheme = _lightTheme2.default;
exports.defaultTheme = defaultTheme;
exports.getTheme = getTheme;
exports.ThemeProvider = _styledComponents.ThemeProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/theme/index.js
// module id = 238
// module chunks = 29